<template>
  <search-group title="智能锁查询" @search="findData" @clear="clearValue">
    <Row :gutter="24">
      <Col span="5">
        <Select placeholder="项目名称" v-model="searchData.projectId"  @on-change="changeProject">
          <Option value="">请选择</Option>
          <Option  v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
          <!--<option value=""></option>-->
        </Select>
      </Col>
      <Col span="4">
        <Select placeholder="楼栋" v-model="searchData.buildingId" @on-change="changBuiding">
          <Option value="">{{searchData.projectId !==''?(buildingList.length===0?'暂无数据':'请选择'):'请先选择项目'}}</Option>
          <Option v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select placeholder="楼层" v-model="searchData.floorNumber">
          <Option value="">{{floorList.length===0?'请先选择楼栋':'请选择'}}</Option>
          <Option value="100" v-for="item in floorList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select placeholder="房间状态" v-model="searchData.roomStatus">
          <Option value="">请选择</Option>
          <Option v-for="item in roomStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="3">
        <Input placeholder="入住人" v-model="searchData.userName" @keyup.enter.native="findData"></Input>
      </Col>
      <Col span="3">
        <Input placeholder="房间号" v-model="searchData.roomNumber" @keyup.enter.native="findData"></Input>
      </Col>
    </Row>
  </search-group>
</template>
<script>
  // import SearchGroup from 'components/SearchGroup/index';

  export default {
    name: "SearchList",
    components: {
       // SearchGroup
    },
    props: {
      projectList: {
        type: Array,
        default:null
      },
      roomStatusList:{
        type:Array,
        default:null
      },
      setDefault:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        searchData: {
          projectId: '',
          buildingId: '',
          floorNumber: '',
          roomStatus: '',
          userName: '',  //入住人
          roomNumber: '',
          page:1,
          limit:10
        },
        buildingList:[],
        floorList:[],
      }
    },
    watch:{
      setDefault(value){
        value==true&&(this.searchData.projectId=this.projectList[0].value)
      }
    },
    methods:{
      findData(){
        if(this.searchData.projectId==''){
          this.$Message.info('请选择项目')
          return
        }
        this.$emit('findData', this.searchData);
      },
      clearValue(){
        this.searchData={
          projectId: '',
          buildingId: '',
          floorNumber: '',
          roomStatus: '',
          userName: '',  //入住人
          roomNumber: '',
          page:1,
          limit:10
        }

      },
      changeProject(value) {
        for (let [index, item] of this.projectList.entries()) {
          if (value === item.value) {
            this.buildingList = this.projectList[index].children;
          }
        }
        if(!this.searchData.projectId){
          this.buildingList=[]
        }
        this.floorList=[]
      },
      changBuiding(value) {
        for (let [index, item] of this.buildingList.entries()) {
          if (value === item.value) {
            this.floorList = this.buildingList[index].children;
          }
          if(!this.searchData.buildingId){
            this.floorList=[]
          }
        }
      }

    }

  }
</script>

<style scoped>

</style>
